import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Facts = [
    { label: 'Education', value: 'B.S. Computer Science, Mathematics Minor — University of Maryland' },
    { label: 'Focus Areas', value: 'Artificial Intelligence & Machine Learning' },
    { label: 'Current Role', value: 'Applied AI Project Manager, InSite Intelligence' },
    { label: 'Core Languages', value: 'Java, Python, JavaScript, C' },
]

const LanguageTags = ['Java', 'Python', 'JavaScript', 'C', 'Ruby', 'OCaml']
const FrameworkTags = ['React', 'Angular', 'Node.js', 'macOS', 'Linux', 'Windows']
const ToolTags = ['Git', 'GitHub', 'AWS', 'Azure', 'MS Office']
const ConceptTags = ['Machine Learning', 'Artificial Intelligence', 'Cloud Computing', 'Computer Networks', 'Database Design']
const InterestTags = ['Water Polo', 'Chess (FIDE Rated)', 'Piano', 'Golf', 'Pickleball', 'Investing']

const About = () => {
    return (
        <>
            <section className='bg-primary py-4'>
                <Container>
                    <h1 className='text-uppercase text-center text-secondary'>About Me</h1>
                    <hr className='star-dark mb-0'/>
                    <h4 className='text-center text-secondary'>A Closer Look at My Background, Skills, and Interests</h4>
                </Container>
            </section>

            <section>
                <Container>
                    <Row>
                        <Col lg={9} className='mx-auto'>
                            <h2 className='section-eyebrow'>Background</h2>
                            <p className='fs-5 text-secondary'>
                                Curiosity has shaped most of the choices in my life, from taking apart electronics as
                                a child to studying artificial intelligence in college. Born in Washington, D.C. and
                                raised between Annapolis and Bethesda, Maryland, I attended The Landon School before
                                pursuing a Computer Science degree, with a Mathematics minor, at the University of
                                Maryland, where I also completed the two-year Business Scholars program. That
                                combination of an inquisitive nature and disciplined study built the resilience,
                                adaptability, and creativity I bring to every project and team I join today.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-tint py-5'>
                <Container>
                    <div className='fact-grid'>
                        {Facts.map((fact) => (
                            <div className='fact-card' key={fact.label}>
                                <div className='fact-label'>{fact.label}</div>
                                <p className='fact-value'>{fact.value}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            <section>
                <Container>
                    <Row>
                        <Col lg={9} className='mx-auto'>
                            <h2 className='section-eyebrow'>Professional Focus</h2>
                            <p className='fs-5 text-secondary'>
                                My professional path has spanned application design, full-stack web development,
                                and applied machine learning. I currently serve as Applied AI Project Manager at
                                InSite Intelligence, where I lead a team of four engineers building a cutting-edge,
                                AI-integrated building management platform. Previously, at Current iQ, I managed a
                                small development team that built a live, reactive turbine data analytics platform.
                                As Chief Technology Officer at Fiable Solutions, I built a responsive React
                                application backed by a serverless Google Firebase architecture, and integrated
                                modern AI models into its user-facing tools. At DXC Technology, I maintained and
                                extended a Java application used by shipyard workers at a General Dynamics submarine
                                manufacturing facility. Across each role, I pair technical depth with a strategic,
                                business-minded approach to deliver systems that create measurable value for the
                                people who use them.
                            </p>
                            <Link to='/experience' className='fw-semibold'>View my full experience &rarr;</Link>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-tint'>
                <Container>
                    <Row>
                        <Col lg={9} className='mx-auto'>
                            <h2 className='section-eyebrow'>Leadership</h2>
                            <p className='fs-5 text-secondary'>
                                Leadership has been a constant alongside my technical work. As President of the
                                University of Maryland Club Water Polo team for two years, I ran tournament logistics,
                                league coordination, budgets, and coaching. As Vice President of the Sigma Phi Delta
                                fraternity, I helped manage recruitment, professional and brotherhood events, and the
                                organization's annual budget. Both roles sharpened the organizational and
                                interpersonal skills I now rely on when leading development teams and coordinating
                                cross-functional projects.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section>
                <Container>
                    <Row>
                        <Col lg={9} className='mx-auto'>
                            <h2 className='section-eyebrow'>Skills &amp; Interests</h2>
                            <div className='tag-group'>
                                <div className='tag-group-label'>Languages</div>
                                {LanguageTags.map((tag) => <span className='tag-pill' key={tag}>{tag}</span>)}
                            </div>
                            <div className='tag-group'>
                                <div className='tag-group-label'>Frameworks &amp; Operating Systems</div>
                                {FrameworkTags.map((tag) => <span className='tag-pill' key={tag}>{tag}</span>)}
                            </div>
                            <div className='tag-group'>
                                <div className='tag-group-label'>Cloud &amp; Tools</div>
                                {ToolTags.map((tag) => <span className='tag-pill' key={tag}>{tag}</span>)}
                            </div>
                            <div className='tag-group'>
                                <div className='tag-group-label'>Core Concepts</div>
                                {ConceptTags.map((tag) => <span className='tag-pill' key={tag}>{tag}</span>)}
                            </div>
                            <div className='tag-group'>
                                <div className='tag-group-label'>Beyond Work</div>
                                {InterestTags.map((tag) => <span className='tag-pill' key={tag}>{tag}</span>)}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default About;
